import PropTypes from 'prop-types';
import React from 'react';

import Order from '../../../records/Order';
import { translate as t } from '../../../lib/I18n';

import PureRenderComponent from '../../PureRenderComponent';
import DeliveryInformationCollection from './DeliveryInformationCollection';
import DeliveryInformationPostal from './DeliveryInformationPostal';
import DeliveryInformationPrintAtHome from './DeliveryInformationPrintAtHome';
import DeliveryInformationETicket from './DeliveryInformationETicket';
import SmartOrderSummary from './SmartOrderSummary';
import DeliveryInformationSTicket from './DeliveryInformationSTicket';

class DeliveryInformation extends PureRenderComponent {

    static propTypes = {
        order: PropTypes.instanceOf(Order).isRequired,
        isLoggedIn: PropTypes.bool
    };

    static defaultProps = {
        isLoggedIn: false
    };

    render () {
        const { order } = this.props;
        const { delivery } = order;

        const { isInterop } = order;

        if (!order.isPaid()) {
            return null;
        }

        const hasFlexiFares = order.getFares().some(x => x.isFlexi());

        if (delivery.isCollection()) {
            return <DeliveryInformationCollection { ...this.props } />;
        } else if (delivery.isPostalDelivery()) {
            return <DeliveryInformationPostal { ...this.props } />;
        } else if (delivery.isSmartcard() && !order.hasCollectionWindowEnded() && !order.isFullRefund) {
            let message = '';
            if (order.isSmartcardWithProductDelivery()) {
                message = t('order.details.smartcardWithProductDelivery');
            } else if (delivery.hasCollectionLocation()) {
                message = (
                    <SmartOrderSummary
                        location={delivery.collectionLocation.name}
                        brand={t('app.owner.short')}
                        isInterop={isInterop}
                        hasFlexiFares={hasFlexiFares}
                    />
                );
            }
            return <p>{ message }</p>;
        } else if (delivery.isSTicket()) {
            return <DeliveryInformationSTicket brand={t('app.owner.short')} />;
        }
        else if (delivery.isPrintAtHome()) {
            return <DeliveryInformationPrintAtHome { ...this.props } />;
        } else if (delivery.isETicket()) {
            return (<DeliveryInformationETicket email={order.get('email')}
                                               isGuest={order.isGuestOrder()}
                                               isPaypal={order.hasPaypalPayment()}
                                               isAmazonPay={order.hasAmazonPayPayment()}/>);
        }

        return null;
    }
}

export default DeliveryInformation;



// WEBPACK FOOTER //
// ./src/components/checkout/orderSummary/DeliveryInformation.js